import store from "@frameworks/web/redux/store";
import { SERVICE_LIST, SERVICE_LIST_ERROR, SERVICE_LIST_HIDE_ERROR, SERVICE_LIST_START_LOADER, SERVICE_LIST_STOP_LOADER, } from "../interface/IServiceList";
class ServiceListActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    getServiceList(data) {
        this.dispatch({
            type: SERVICE_LIST,
            payload: { data },
        });
    }
    setError(payload) {
        this.dispatch({
            type: SERVICE_LIST_ERROR,
            payload: { errorData: payload },
        });
    }
    hideError() {
        this.dispatch({
            type: SERVICE_LIST_HIDE_ERROR,
        });
    }
    startLoader() {
        this.dispatch({
            type: SERVICE_LIST_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: SERVICE_LIST_STOP_LOADER,
        });
    }
}
export default ServiceListActions;
